import { useListBrowserUtils } from '@ts-private/list-browser';
import logsStore from './logsStore';
import { useEffect } from 'react';

const useLogFilters = () => {
  const { store, update } = useListBrowserUtils(logsStore);

  useEffect(() => {
    update(prev => {
      const hiddenFilters = [];
      if (!prev.filters.startDate) hiddenFilters.push('startTime');
      if (!prev.filters.endDate) hiddenFilters.push('endTime');
      return { ...prev, hiddenFilters };
    });
  }, [update, store.filters ]);
};

export default useLogFilters;
